import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class KatBorcKontrolAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "KatBorcKontrol";
        super(baseUrl);
    }
    getKatBorcKontrol(SqId: number, Durum: number) {
        var request = new KatBorcKontrolRequest(SqId, Durum);

        return this.post("", request, false);
    }
}

export default new KatBorcKontrolAPI();
class KatBorcKontrolRequest {
    public sqId: number;
    public durum: number;

    constructor(sqId: number, durum: number) {

        this.sqId = sqId;
        this.durum = durum;

    }
}
export { KatBorcKontrolRequest };